import React from 'react';
import './more.css';

// Mobile "More" hub — the 5th-ish destination behind the bottom nav.
// Collects the actions that don't have their own bottom-nav tab. On desktop
// this screen is reachable via #more but isn't surfaced in the desktop tab
// chrome (the desktop app exposes these via its own affordances).

const Chevron = () => (
  <svg className="more-chev" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="m9 18 6-6-6-6"/></svg>
);

function Row({ tile, tileColor, title, desc, onClick }) {
  return (
    <button type="button" className="more-row" onClick={onClick}>
      <span className="more-tile" style={{ background: tileColor }}>{tile}</span>
      <span className="more-body">
        <span className="more-title">{title}</span>
        <span className="more-desc">{desc}</span>
      </span>
      <Chevron />
    </button>
  );
}

export default function More({ navigate }) {
  const go = (screen) => () => navigate && navigate(screen);
  // Returning to the gold module is a parent-app concern. Prefer an explicit
  // hook if the parent exposes one; otherwise click the parent's existing
  // top-level "Dashboard" tab button (data-tab="dashboard") so we don't need
  // to modify the parent index.html at all.
  const toGold = () => {
    if (typeof window === 'undefined') return;
    if (typeof window.finopsSwitchTab === 'function') { window.finopsSwitchTab('dashboard'); return; }
    const btn = document.querySelector('.tab-btn[data-tab="dashboard"]');
    if (btn) btn.click();
  };
  return (
    <div className="page more-page">
      <div className="page-title-row">
        <div>
          <div className="page-eyebrow">Investment</div>
          <h1 className="page-title">More</h1>
        </div>
      </div>

      <div className="card more-card">
        <Row tile="?" tileColor="#4f46e5" title="How to use this app"
             desc="A quick visual guide · start here"
             onClick={() => { if (typeof window !== 'undefined') window.open('/guide/', '_blank', 'noopener'); }} />
      </div>

      <div className="card more-card">
        <Row tile="$" tileColor="#059669" title="Settlements & cadence"
             desc="Pay Kareem · change your monthly nudge · monthly" onClick={go('settlements')} />
      </div>

      <div className="card more-card">
        <Row tile="＋" tileColor="#7c3aed" title="Add a sub-account"
             desc="Bring a family member into the household · rare" onClick={go('add-subaccount')} />
        <Row tile="⌁" tileColor="#d97706" title="Connectivity"
             desc="Email sources & auto-logging · one-time setup" onClick={go('email-sources')} />
      </div>

      <div className="card more-card">
        <Row tile="↩" tileColor="#1e293b" title="Switch to gold module"
             desc="Back to the main FinOps app" onClick={toGold} />
      </div>

      <div className="more-foot">FinOps · Investment</div>
    </div>
  );
}
